import {
  deleteOwnAccount as deleteOwnAccountAction,
  logout as logoutAction,
} from 'src/slices/auth';
import { AppDispatch, resetStore } from 'src/store';

export const logout = async (dispatch: AppDispatch) => {
  dispatch(resetStore());
  dispatch(logoutAction());
};

export const deleteOwnAccount = async (dispatch: AppDispatch) => {
  dispatch(deleteOwnAccountAction());
  logout(dispatch);
};
